import React, { useState } from 'react';

import { CheckBox, LabeledInput, SelectInput } from '../../../Components';

const Index = ({ product, deliverycost, printType, itemPrice, setItemPrice }) => {
    return (
        <div>
            {printType && (
                <p className="product_detail">
                    Calculate the price of the {product} based on the Print Type of the design:
                </p>
            )}
            {printType === 'Digital print design' ? (
                <DigitalPrint
                    deliverycost={deliverycost}
                    setItemPrice={setItemPrice}
                    itemPrice={itemPrice}
                    product={product}
                />
            ) : printType === 'UV printing' ? (
                <UVPrint
                    deliverycost={deliverycost}
                    setItemPrice={setItemPrice}
                    itemPrice={itemPrice}
                    product={product}
                />
            ) : printType === 'Vinyl Printing' ? (
                <VinylPrint
                    deliverycost={deliverycost}
                    setItemPrice={setItemPrice}
                    itemPrice={itemPrice}
                    product={product}
                />
            ) : printType === 'Sublimation Print Design' ? (
                <SublimationPrint
                    deliverycost={deliverycost}
                    setItemPrice={setItemPrice}
                    itemPrice={itemPrice}
                    product={product}
                />
            ) : printType === 'Screen Print Design' ? (
                <ScreenPrint
                    deliverycost={deliverycost}
                    setItemPrice={setItemPrice}
                    itemPrice={itemPrice}
                    product={product}
                />
            ) : (
                ''
            )}
        </div>
    );
};

const ScreenPrintPrice = {
    gst: 5,
    'T-Shirt': {
        printCost: 65,
        printCostAddon: 15,
        additionalPrint: 30,
        maxWidth: 11.5,
        maxHeight: 16,
        screenPrice: 250,
        screenPriceAddOn: 250,
        label: {
            screenPrice: 150,
            printPrice: 7,
            maxWidth: 3,
            maxHeight: 2.5,
        },
        seelve: {
            printCost: 20,
            additionaPrint: 15,
            maxWidth: 3.5,
            maxHeight: 3.5,
        },
    },
    Hoodie: {
        printCost: 75,
        printCostAddon: 25,
        additionalPrint: 30,
        maxWidth: 10,
        maxHeight: 8,
        screenPrice: 250,
        screenPriceAddOn: 250,
        label: {
            screenPrice: 150,
            printPrice: 7,
            maxWidth: 3,
            maxHeight: 2.5,
        },
        seelve: {
            printCost: 20,
            additionaPrint: 15,
            maxWidth: 3.5,
            maxHeight: 3.5,
        },
    },
};

const ScreenPrint = ({ product, deliverycost, setItemPrice, itemPrice }) => {
    const [width, setWidth] = useState(10);
    const [heigth, setHeight] = useState(8);
    const [colorFirst, setColorFirst] = useState(1);
    const [colorSecond, setColorSecond] = useState(1);
    const [hasaNeckLabel, setNeckLabel] = useState(false);
    const [additionaPrint, setadditionaPrint] = useState(false);
    const [hasaBackLabel, setBacklabel] = useState(false);
    const [isSleevePrint, setSleevePrint] = useState(false);

    const [colorThird, setColorThird] = useState(1);

    const neckLabelCheckhandler = (name, currentState) => {
        setNeckLabel(!currentState);
    };
    const backLabelCheckHandler = (name, currentState) => {
        setBacklabel(!currentState);
    };
    const addtionalPrintChangeHandler = (name, currentState) => {
        setadditionaPrint(!currentState);
    };
    const sleevePrintChangeHandler = (name, currentState) => {
        setSleevePrint(!currentState);
    };
    const onCalculateHandler = () => {
        let price = itemPrice + ScreenPrintPrice[product].printCost;

        price += (colorFirst - 1) * ScreenPrintPrice[product].printCostAddon;

        if (hasaNeckLabel) {
            price += ScreenPrintPrice[product].label.printPrice;
        }

        if (additionaPrint) {
            price += (colorSecond - 1) * ScreenPrintPrice[product].printCostAddon;

            price += ScreenPrintPrice[product].additionalPrint;
        }

        if (hasaBackLabel) {
            price += ScreenPrintPrice[product].label.printPrice;
        }

        if (isSleevePrint) {
            price += ScreenPrintPrice[product].seelve.printCost;
            price += (colorThird - 1) * ScreenPrintPrice[product].seelve.additionaPrint;
        }

        price += price * (ScreenPrintPrice.gst / 100) + deliverycost;

        setItemPrice(price);
    };

    return (
        <div>
            <h2 className="MP-H">Screen Print Details</h2>
            <div>
                <p className="MP-P">
                    <span>{product} Price:</span> {itemPrice}₹
                </p>
                <p style={{ marginBottom: '3rem' }} className="MP-P">
                    <span>Delivery Cost:</span> {deliverycost}₹
                </p>
                <p style={{ marginBottom: '3rem' }} className="MP-P">
                    <span>One Time Screen Price:</span> {ScreenPrintPrice[product].screenPrice}₹
                </p>

                <LabeledInput
                    style={{ width: '100%', maxWidth: '280px', marginBottom: '2rem' }}
                    type="number"
                    name="Width"
                    value={width}
                    changeHandler={(e) => {
                        setWidth(e.target.value);
                    }}
                    label={`Design Width (in inches) - Max. ${ScreenPrintPrice[product].maxWidth} inches*`}
                />
                <LabeledInput
                    style={{ width: '100%', maxWidth: '280px', marginBottom: '1rem' }}
                    type="number"
                    name="Height"
                    value={heigth}
                    changeHandler={(e) => {
                        setHeight(e.target.value);
                    }}
                    label={`Design Height (in inches) - Max. ${ScreenPrintPrice[product].maxHeight} inches*`}
                />
                <p style={{ marginBottom: '2rem' }} className="input_info">
                    *Contact for bigger design size, printing possible 13 x 17.5 inches
                </p>
                <CheckBox
                    style={{ marginBottom: '0' }}
                    name="printed"
                    value="printed"
                    labeling="Front Design Print"
                    checked={true}
                />
                <p style={{ marginBottom: '2rem' }} className="input_info">
                    Print has Fix Price of {ScreenPrintPrice[product].printCost}₹ with add-on price per color of{' '}
                    {ScreenPrintPrice[product].printCostAddon}₹ (Maximum Dimension :{' '}
                    {ScreenPrintPrice[product].maxHeight}in X{ScreenPrintPrice[product].maxWidth}in)
                </p>
                <div style={{ width: 'max-content' }}>
                    <SelectInput
                        style={{ width: 'max-content' }}
                        label="Number of Colors in Front/Back Design"
                        outlined={true}
                        value={colorFirst}
                        changeHandler={(e) => {
                            setColorFirst(e.target.value);
                        }}
                        options={[
                            { name: '1', value: 1 },
                            { name: '2', value: 2 },
                            { name: '3', value: 3 },
                            { name: '4', value: 4 },
                            { name: '5', value: 5 },
                            { name: '6', value: 6 },
                        ]}
                    />
                </div>
                <CheckBox
                    style={{ marginBottom: '0' }}
                    name="isAdditionalPrinted"
                    value="isAdditionalPrinted"
                    labeling="Additional Back Design Print"
                    checked={false}
                    handleChange={addtionalPrintChangeHandler}
                />
                <p style={{ marginBottom: '2rem' }} className="input_info">
                    Additional Print has Fix Price of {ScreenPrintPrice[product].additionaPrint}₹ with add-on price per
                    color of {ScreenPrintPrice[product].printCostAddon}₹ (Maximum Dimension :{' '}
                    {ScreenPrintPrice[product].maxHeight}in X{ScreenPrintPrice[product].maxWidth}in)
                </p>
                <div style={{ width: 'max-content' }}>
                    <SelectInput
                        style={{ width: 'max-content' }}
                        label="Number of Colors in Additional Front/Back Design"
                        outlined={true}
                        value={colorSecond}
                        changeHandler={(e) => {
                            setColorSecond(e.target.value);
                        }}
                        options={[
                            { name: '1', value: 1 },
                            { name: '2', value: 2 },
                            { name: '3', value: 3 },
                            { name: '4', value: 4 },
                            { name: '5', value: 5 },
                            { name: '6', value: 6 },
                        ]}
                    />
                </div>
                <CheckBox
                    style={{ marginBottom: '0' }}
                    name="isSleevePrinted"
                    value="isSleevePrinted"
                    labeling="Sleeve Printed"
                    checked={false}
                    handleChange={sleevePrintChangeHandler}
                />
                <p style={{ marginBottom: '2rem' }} className="input_info">
                    Sleeve Print has Fix Price of {ScreenPrintPrice[product].seelve.additionaPrint}₹ with add-on price
                    per color of {ScreenPrintPrice[product].seelve.additionaPrint}₹ (Maximum Dimension :{' '}
                    {ScreenPrintPrice[product].seelve.maxHeight}in X{ScreenPrintPrice[product].seelve.maxWidth}in)
                </p>
                <div style={{ width: 'max-content' }}>
                    <SelectInput
                        style={{ width: 'max-content' }}
                        label="Number of Colors in Sleeve Design"
                        outlined={true}
                        value={colorThird}
                        changeHandler={(e) => {
                            setColorThird(e.target.value);
                        }}
                        options={[
                            { name: '1', value: 1 },
                            { name: '2', value: 2 },
                            { name: '3', value: 3 },
                            { name: '4', value: 4 },
                            { name: '5', value: 5 },
                            { name: '6', value: 6 },
                        ]}
                    />
                </div>
                <CheckBox
                    style={{ marginBottom: '0' }}
                    handleChange={neckLabelCheckhandler}
                    name="isNeckLabel5"
                    value="isNeckLabel5"
                    labeling="has a Neck Label?"
                    checked={false}
                />
                <p style={{ marginBottom: '2rem' }} className="input_info">
                    Neck Label has fix price {ScreenPrintPrice[product].label.printPrice}₹ (Maximum Dimension :{' '}
                    {ScreenPrintPrice[product].label.maxHeight}in X{ScreenPrintPrice[product].label.maxWidth}in)
                </p>
                <CheckBox
                    style={{ marginBottom: '0' }}
                    handleChange={backLabelCheckHandler}
                    name="isBacklabel"
                    value="isBacklabel"
                    labeling="has a Back Label?"
                    checked={false}
                />
                <p style={{ marginBottom: '2rem' }} className="input_info">
                    Neck Label has fix price {ScreenPrintPrice[product].label.printPrice}₹ (Maximum Dimension :{' '}
                    {ScreenPrintPrice[product].label.maxHeight}in X{ScreenPrintPrice[product].label.maxWidth}in)
                </p>
                <button onClick={onCalculateHandler} className="btn-orange">
                    <p>Calculate</p>
                </button>
            </div>
        </div>
    );
};

const SublimationPrintPrice = {
    gst: 5,

    'T-Shirt': {
        printCost: 60,
        neckLabelPrice: 7,
    },
};

const SublimationPrint = ({ product, deliverycost, setItemPrice, itemPrice }) => {
    const [hasaNeckLabel, setNeckLabel] = useState(false);
    const neckLabelCheckhandler = (name, currentState) => {
        setNeckLabel(!currentState);
    };

    const onCalculateHandler = () => {
        let price = itemPrice + SublimationPrintPrice[product].printCost;
        if (hasaNeckLabel) {
            price += SublimationPrintPrice[product].neckLabelPrice;
        }
        price += price * (parseFloat(SublimationPrintPrice.gst) / 100) + deliverycost;
        setItemPrice(price);
    };

    return (
        <div>
            <h2 className="MP-H"> Sublimation Printing</h2>

            <div>
                <div>
                    <p className="MP-P">
                        <span>{product} Price:</span> {itemPrice}₹
                    </p>
                    <p className="MP-P">
                        <span>Delivery Cost:</span> {deliverycost}₹
                    </p>

                    <p className="MP-P">
                        <span>
                            Sublimation print will always has a max of A4 size printing with fix Price of{' '}
                            {SublimationPrintPrice[product].printCost}₹.
                        </span>
                    </p>
                    <CheckBox
                        style={{ marginBottom: '0' }}
                        handleChange={neckLabelCheckhandler}
                        name="isNeckLabel2"
                        value="isNeckLabel2"
                        labeling="has a Neck Label?"
                        checked={false}
                    />
                    <p style={{ marginBottom: '2rem' }} className="input_info">
                        Neck Label has fix price {SublimationPrintPrice[product].neckLabelPrice}₹
                    </p>
                    <button onClick={onCalculateHandler} className="btn-orange">
                        <p>Calculate</p>
                    </button>
                </div>
            </div>
        </div>
    );
};

const DigitalPrintPrices = {
    gst: 5,
    Hoodie: {
        costPer: 1.1,
        chestLogo: 80,
        neckLabel: {
            price: 10,
            maxHeight: 2.5,
            maxWidth: 3,
        },
        minimumPrice: 110,
        screenPrice: 150,
        maxWidth: 8,
        maxHeight: 10,
    },
    'T-Shirt': {
        costPer: 1,
        chestLogo: 80,
        neckLabel: {
            price: 7,
            maxHeight: 2.5,
            maxWidth: 3,
        },
        screenPrice: 150,
        minimumPrice: 85,
        maxWidth: 12,
        maxHeight: 18,
    },
};

const DigitalPrint = ({ product, deliverycost, setItemPrice, itemPrice }) => {
    const [width, setWidth] = useState(10);
    const [heigth, setHeight] = useState(10);
    const [isChestlogo, SetIsChestLogo] = useState(false);

    const [hasaNeckLabel, setNeckLabel] = useState(false);

    const materialCheckhandler = (name, currentState) => {
        SetIsChestLogo(!currentState);
    };
    const neckLabelCheckhandler = (name, currentState) => {
        setNeckLabel(!currentState);
    };
    const onCalculateHandler = () => {
        const designPrice = isChestlogo
            ? DigitalPrintPrices[product].chestLogo
            : Math.max(DigitalPrintPrices[product].minimumPrice, width * heigth * DigitalPrintPrices[product].costPer);
        let price = itemPrice + designPrice;
        if (hasaNeckLabel) {
            price += DigitalPrintPrices[product].neckLabel.price;
        }
        price += price * (5 / 100) + deliverycost;
        setItemPrice(price);
    };

    return (
        <div>
            <h2 className="MP-H">Digital Print Details</h2>
            <p className="MP-P">
                <span>{product} Cost:</span> {itemPrice}₹
            </p>
            <p className="MP-P">
                <span>Delivery Cost:</span> {deliverycost}₹
            </p>
            <p style={{ marginBottom: '3rem' }} className="MP-P">
                <span>One Time Screen Price:</span> {DigitalPrintPrices[product].screenPrice}₹
            </p>
            <p style={{ marginBottom: '3rem' }} className="input_info">
                Minimum Cost of Printing: {DigitalPrintPrices[product].minimumPrice}₹
            </p>

            <LabeledInput
                style={{ width: '100%', maxWidth: '280px', marginBottom: '2rem' }}
                disbale={isChestlogo}
                type="number"
                name="Width"
                value={isChestlogo ? 0 : width}
                changeHandler={(e) => {
                    setWidth(e.target.value);
                }}
                label={`Design Width (in inches) - Max. ${DigitalPrintPrices[product].maxWidth} inches*`}
            />
            <LabeledInput
                style={{ width: '100%', maxWidth: '280px' }}
                disbale={isChestlogo}
                type="number"
                name="Height"
                value={isChestlogo ? 0 : heigth}
                changeHandler={(e) => {
                    setHeight(e.target.value);
                }}
                label={`Design Height (in inches) - Max. ${DigitalPrintPrices[product].maxHeight} inches*`}
            />
            <CheckBox
                style={{ marginBottom: '0' }}
                handleChange={materialCheckhandler}
                name="IsChestLogo"
                value="IsChestLogo"
                labeling="Is Chest Logo?"
                checked={false}
            />
            <p style={{ marginBottom: '2rem' }} className="input_info">
                Chest Logo has fix price {DigitalPrintPrices[product].chestLogo}₹
            </p>
            <CheckBox
                style={{ marginBottom: '0' }}
                handleChange={neckLabelCheckhandler}
                name="isNeckLabel"
                value="isNeckLabel"
                labeling="has a Neck Label?"
                checked={false}
            />
            <p style={{ marginBottom: '2rem' }} className="input_info">
                Neck Label has fix price {DigitalPrintPrices[product].neckLabel.price}₹ (Maximum Dimension :{' '}
                {DigitalPrintPrices[product].neckLabel.maxWidth}in X{DigitalPrintPrices[product].neckLabel.maxHeight}in)
            </p>

            <button onClick={onCalculateHandler} className="btn-orange">
                <p>Calculate</p>
            </button>
        </div>
    );
};

const VinylPrintPrices = {
    gst: 5,
    Hoodie: {
        costPer: 1.1,
        chestLogo: 80,
        neckLabel: {
            price: 10,
            maxHeight: 2.5,
            maxWidth: 3,
        },
        minimumPrice: 110,
        screenPrice: 150,
        maxWidth: 8,
        maxHeight: 10,
    },
    'T-Shirt': {
        costPer: 1,
        chestLogo: 80,
        neckLabel: {
            price: 7,
            maxHeight: 2.5,
            maxWidth: 3,
        },
        screenPrice: 150,
        minimumPrice: 85,
        maxWidth: 12,
        maxHeight: 18,
    },
};

const VinylPrint = ({ product, deliverycost, setItemPrice, itemPrice }) => {
    const [width, setWidth] = useState(10);
    const [heigth, setHeight] = useState(10);
    const [isChestlogo, SetIsChestLogo] = useState(false);

    const [hasaNeckLabel, setNeckLabel] = useState(false);

    const materialCheckhandler = (name, currentState) => {
        SetIsChestLogo(!currentState);
    };
    const neckLabelCheckhandler = (name, currentState) => {
        setNeckLabel(!currentState);
    };
    const onCalculateHandler = () => {
        const designPrice = isChestlogo
            ? VinylPrintPrices[product].chestLogo
            : Math.max(VinylPrintPrices[product].minimumPrice, width * heigth * VinylPrintPrices[product].costPer);
        let price = itemPrice + designPrice;
        if (hasaNeckLabel) {
            price += VinylPrintPrices[product].neckLabel.price;
        }
        price += price * (5 / 100) + deliverycost;
        setItemPrice(price);
    };

    return (
        <div>
            <h2 className="MP-H">Vinyl Print Details</h2>
            <p className="MP-P">
                <span>{product} Cost:</span> {itemPrice}₹
            </p>
            <p className="MP-P">
                <span>Delivery Cost:</span> {deliverycost}₹
            </p>
            <p style={{ marginBottom: '3rem' }} className="MP-P">
                <span>One Time Screen Price:</span> {VinylPrintPrices[product].screenPrice}₹
            </p>
            <p style={{ marginBottom: '3rem' }} className="input_info">
                Minimum Cost of Printing: {VinylPrintPrices[product].minimumPrice}₹
            </p>

            <LabeledInput
                style={{ width: '100%', maxWidth: '280px', marginBottom: '2rem' }}
                disbale={isChestlogo}
                type="number"
                name="Width"
                value={isChestlogo ? 0 : width}
                changeHandler={(e) => {
                    setWidth(e.target.value);
                }}
                label={`Design Width (in inches) - Max. ${VinylPrintPrices[product].maxWidth} inches*`}
            />
            <LabeledInput
                style={{ width: '100%', maxWidth: '280px' }}
                disbale={isChestlogo}
                type="number"
                name="Height"
                value={isChestlogo ? 0 : heigth}
                changeHandler={(e) => {
                    setHeight(e.target.value);
                }}
                label={`Design Height (in inches) - Max. ${VinylPrintPrices[product].maxHeight} inches*`}
            />
            <CheckBox
                style={{ marginBottom: '0' }}
                handleChange={materialCheckhandler}
                name="IsChestLogo"
                value="IsChestLogo"
                labeling="Is Chest Logo?"
                checked={false}
            />
            <p style={{ marginBottom: '2rem' }} className="input_info">
                Chest Logo has fix price {VinylPrintPrices[product].chestLogo}₹
            </p>
            <CheckBox
                style={{ marginBottom: '0' }}
                handleChange={neckLabelCheckhandler}
                name="isNeckLabel"
                value="isNeckLabel"
                labeling="has a Neck Label?"
                checked={false}
            />
            <p style={{ marginBottom: '2rem' }} className="input_info">
                Neck Label has fix price {VinylPrintPrices[product].neckLabel.price}₹ (Maximum Dimension :{' '}
                {VinylPrintPrices[product].neckLabel.maxWidth}in X{VinylPrintPrices[product].neckLabel.maxHeight}in)
            </p>

            <button onClick={onCalculateHandler} className="btn-orange">
                <p>Calculate</p>
            </button>
        </div>
    );
};

const UVPrintPrices = {
    gst: 5,
    Hoodie: {
        costPer: 1.1,
        chestLogo: 80,
        neckLabel: {
            price: 10,
            maxHeight: 2.5,
            maxWidth: 3,
        },
        minimumPrice: 110,
        screenPrice: 150,
        maxWidth: 8,
        maxHeight: 10,
    },
    'T-Shirt': {
        costPer: 1,
        chestLogo: 80,
        neckLabel: {
            price: 7,
            maxHeight: 2.5,
            maxWidth: 3,
        },
        screenPrice: 150,
        minimumPrice: 85,
        maxWidth: 12,
        maxHeight: 18,
    },
};

const UVPrint = ({ product, deliverycost, setItemPrice, itemPrice }) => {
    const [width, setWidth] = useState(10);
    const [heigth, setHeight] = useState(10);
    const [isChestlogo, SetIsChestLogo] = useState(false);

    const [hasaNeckLabel, setNeckLabel] = useState(false);

    const materialCheckhandler = (name, currentState) => {
        SetIsChestLogo(!currentState);
    };
    const neckLabelCheckhandler = (name, currentState) => {
        setNeckLabel(!currentState);
    };
    const onCalculateHandler = () => {
        const designPrice = isChestlogo
            ? UVPrintPrices[product].chestLogo
            : Math.max(UVPrintPrices[product].minimumPrice, width * heigth * UVPrintPrices[product].costPer);
        let price = itemPrice + designPrice;
        if (hasaNeckLabel) {
            price += UVPrintPrices[product].neckLabel.price;
        }
        price += price * (5 / 100) + deliverycost;
        setItemPrice(price);
    };

    return (
        <div>
            <h2 className="MP-H">UV Print Details</h2>
            <p className="MP-P">
                <span>{product} Cost:</span> {itemPrice}₹
            </p>
            <p className="MP-P">
                <span>Delivery Cost:</span> {deliverycost}₹
            </p>
            <p style={{ marginBottom: '3rem' }} className="MP-P">
                <span>One Time Screen Price:</span> {UVPrintPrices[product].screenPrice}₹
            </p>
            <p style={{ marginBottom: '3rem' }} className="input_info">
                Minimum Cost of Printing: {UVPrintPrices[product].minimumPrice}₹
            </p>

            <LabeledInput
                style={{ width: '100%', maxWidth: '280px', marginBottom: '2rem' }}
                disbale={isChestlogo}
                type="number"
                name="Width"
                value={isChestlogo ? 0 : width}
                changeHandler={(e) => {
                    setWidth(e.target.value);
                }}
                label={`Design Width (in inches) - Max. ${UVPrintPrices[product].maxWidth} inches*`}
            />
            <LabeledInput
                style={{ width: '100%', maxWidth: '280px' }}
                disbale={isChestlogo}
                type="number"
                name="Height"
                value={isChestlogo ? 0 : heigth}
                changeHandler={(e) => {
                    setHeight(e.target.value);
                }}
                label={`Design Height (in inches) - Max. ${UVPrintPrices[product].maxHeight} inches*`}
            />
            <CheckBox
                style={{ marginBottom: '0' }}
                handleChange={materialCheckhandler}
                name="IsChestLogo"
                value="IsChestLogo"
                labeling="Is Chest Logo?"
                checked={false}
            />
            <p style={{ marginBottom: '2rem' }} className="input_info">
                Chest Logo has fix price {UVPrintPrices[product].chestLogo}₹
            </p>
            <CheckBox
                style={{ marginBottom: '0' }}
                handleChange={neckLabelCheckhandler}
                name="isNeckLabel"
                value="isNeckLabel"
                labeling="has a Neck Label?"
                checked={false}
            />
            <p style={{ marginBottom: '2rem' }} className="input_info">
                Neck Label has fix price {UVPrintPrices[product].neckLabel.price}₹ (Maximum Dimension :{' '}
                {UVPrintPrices[product].neckLabel.maxWidth}in X{UVPrintPrices[product].neckLabel.maxHeight}in)
            </p>

            <button onClick={onCalculateHandler} className="btn-orange">
                <p>Calculate</p>
            </button>
        </div>
    );
};

export default Index;
